import axios from '@axios'


const route = 'sales'

export default {
  namespaced: true,
  state: {

  },
  getters: {},
  mutations: {},
  actions: {
    /**
     * Salva configuracao de impressora
     */
    savePrinterConfig(context,  configPrinter ) {
      return axios.post(`${route}/config_printer`, configPrinter)
    },
    /**
     * Carrega configuracao de impressora
     */
    getPrinterConfig(context) {
      return axios.get(`${route}/config_printer`)
    },
  },
}
